<ng-container *ngIf="isloggedin && (router.url === '/' || router.url.indexOf('help-') > -1)">
  <ng-container *ngIf="currentNews">
    <div class="container mt-5">
      <div class="row align-items-start"
           [class.fixed-bottom]="getNewsPosition() === 'bottom'"
           [class.mb-5]="getNewsPosition() === 'bottom'">
        <ng-container *ngIf="getNewsPosition() === 'right'">
          <div class="col"></div>
          <div class="col"></div>
        </ng-container>
        <ng-container *ngIf="getNewsPosition() === 'center' || getNewsPosition() === 'bottom'">
          <div class="col"></div>
        </ng-container>
        <div class="col-md-6 col-sm-12">
          <carousel>
            <slide *ngFor="let appnews of currentNews">
              <div class="card pl-5 pr-5 pb-5 pt-5">
                <div class="container">
                  <div class="row">
                    <div class="col-2 text-center">
                      <ng-container *ngIf="appnews.newstype === 'Warning'">
                        <i class="fas fa-exclamation-triangle fa-3x text-warning"></i>
                      </ng-container>
                      <ng-container *ngIf="appnews.newstype === 'Information'">
                        <i class="fas fa-info-circle fa-3x text-primary"></i>
                      </ng-container>
                      <ng-container *ngIf="appnews.newstype === 'Technique'">
                        <i class="fas fa-tools fa-3x text-primary"></i>
                      </ng-container>
                      <ng-container *ngIf="appnews.newstype === 'Greetings'">
                        <i class="fas fa-handshake fa-3x text-primary"></i>
                      </ng-container>
                      <ng-container *ngIf="appnews.newstype === 'Neutral'">
                      </ng-container>
                    </div>
                    <div class="col-9">
                      <h5>{{convertDate(appnews.newseventdate)}}</h5>
                      <h4 class="card-title">{{appnews.newstitle}}</h4>
                      <div class="card-text" [innerHTML]="appnews.newscontent"></div>
                    </div>
                    <div class="col-1"></div>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
        <ng-container *ngIf="getNewsPosition() === 'left'">
          <div class="col"></div>
          <div class="col"></div>
        </ng-container>
        <ng-container *ngIf="getNewsPosition() === 'center' || getNewsPosition() === 'bottom'">
          <div class="col"></div>
        </ng-container>
      </div>
    </div>

    <!--
    <div class="container">
      <div class="row no-gutters">
        <div class="col-md-6 col-lg-6 me-auto ms-auto mt-5">
          <carousel>
            <slide *ngFor="let appnews of currentNews">
              <div class="card pl-5 pr-5 pb-5 pt-5">
                <div class="container">
                  <div class="row">
                    <div class="col-2">
                      <ng-container *ngIf="appnews.newstype === 'Warning'">
                        <i class="fas fa-exclamation-triangle fa-3x text-warning"></i>
                      </ng-container>
                      <ng-container *ngIf="appnews.newstype === 'Information'">
                        <i class="fas fa-info-circle fa-3x text-primary"></i>
                      </ng-container>
                      <ng-container *ngIf="appnews.newstype === 'Technique'">
                        <i class="fas fa-tools fa-3x text-primary"></i>
                      </ng-container>
                      <ng-container *ngIf="appnews.newstype === 'Greetings'">
                        <i class="fas fa-handshake fa-3x text-primary"></i>
                      </ng-container>
                      <ng-container *ngIf="appnews.newstype === 'Neutral'">
                      </ng-container>
                    </div>
                    <div class="col-8">
                      <h5>{{convertDate(appnews.newseventdate)}}</h5>
                      <h4 class="card-title">{{appnews.newstitle}}</h4>
                      <div class="card-text" [innerHTML]="appnews.newscontent"></div>
                    </div>
                    <div class="col-2"></div>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
    -->

  </ng-container>
</ng-container>
